module.exports = __webpack_public_path__ + "img/inventory-control.ff59b8fc.svg";